export default __webpack_public_path__ + "static/media/awal-mula-hoaks-desktop.95043193.png";